var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card text-center"},[_c('img',{staticClass:"round-img",attrs:{"src":_vm.user.avatar_url,"alt":"avatar"}}),_c('h3',[_vm._v(_vm._s(_vm.user.login))]),_c('div',[_c('router-link',{staticClass:"btn btn-dark btn-sm my-1",attrs:{"to":`/users/${_vm.user.login}`}},[_vm._v(" More ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }